import {Injectable} from "@angular/core";
import {APIProxy} from "../../../../../common/http/services/api.proxy";
import {IDirectoryService} from "../interfaces/directory.service";
import {HttpObservable} from "../../../../../common/http/services/http.wrapper";

@Injectable()
export class DirectoryServiceProxy {
	constructor(private apiHttp:APIProxy) { }

	public getDirectoryServices(): HttpObservable<IDirectoryService[]> {
		return this.apiHttp.getAnon("DirectoryService", "GetDirectoryServices");
	}
}
